import { DialogTop } from "../../../../editComponents/DialogTop/DialogTop";
import styles from "./EventLogoSettings.module.scss";
import { ISiteV2 } from "../../../../interfaces/Site";
import { EventLogo, TEventLogo } from "../../EventLogo";
import { ContentBox } from "../../../../editComponents/ContentBox/ContentBox";
import { Input } from "../../../../editComponents/form/Input/Input";
import { EmulateContentSurface } from "../../../../siteModules/components/EmulateContentSurface/EmulateContentSurface";
import { EventLogoColorPicker } from "./components/EventLogoColorPicker/EventLogoColorPicker";
import { VerticalGapOnChildren } from "../../../../siteModules/components/VerticalGapOnChildren/VerticalGapOnChildren";
import { Slider } from "../../../../editComponents/form/Slider/Slider";

interface IProps {
    eventLogo: TEventLogo;
    updateEventLogo: (eventLogo: TEventLogo) => void;
    close: () => void;
    site?: ISiteV2;
}

export function EventLogoSettings(props: IProps) {
    return (
        <>
            <DialogTop title="Redigera logga" close={props.close} />
            <div className={styles.wrapper}>
                <div className={styles.formWrapper}>
                    <VerticalGapOnChildren>
                        <ContentBox padding={true}>
                            <VerticalGapOnChildren>
                                <div className={styles.formFieldWrapper}>
                                    <Input
                                        label="Förnamn 1"
                                        value={props.eventLogo.name1}
                                        handleChange={(value) =>
                                            props.updateEventLogo({ ...props.eventLogo, name1: value })
                                        }
                                        id="name1"
                                        name="name1"
                                    />
                                </div>
                                <div className={styles.formFieldWrapper}>
                                    <Input
                                        label="Förnamn 2"
                                        value={props.eventLogo.name2}
                                        handleChange={(value) =>
                                            props.updateEventLogo({ ...props.eventLogo, name2: value })
                                        }
                                        id="name2"
                                        name="name2"
                                    />
                                </div>
                            </VerticalGapOnChildren>
                        </ContentBox>

                        {"additionalText" in props.eventLogo ? (
                            <ContentBox padding={true}>
                                <div className={styles.formFieldWrapper}>
                                    <Input
                                        label="Datum/plats"
                                        value={props.eventLogo.additionalText}
                                        handleChange={(value) => {
                                            const eventLogo = { ...props.eventLogo, additionalText: value };
                                            props.updateEventLogo(eventLogo);
                                        }}
                                        id="additionalText"
                                        name="additionalText"
                                    />
                                </div>
                            </ContentBox>
                        ) : null}

                        {"fontSizeInitials" in props.eventLogo ? (
                            <ContentBox padding={true}>
                                <div className={styles.formFieldWrapper}>
                                    <Slider
                                        id="fontSizeInitials"
                                        value={props.eventLogo.fontSizeInitials}
                                        handleChange={(value) => {
                                            const eventLogo = { ...props.eventLogo, fontSizeInitials: value };
                                            props.updateEventLogo(eventLogo);
                                        }}
                                        label="Textstorlek initialer"
                                        name="fontSizeInitials"
                                        min={1}
                                        max={15}
                                    />
                                </div>
                            </ContentBox>
                        ) : null}

                        {"distanceInitialsY" in props.eventLogo && "distanceInitialsX" in props.eventLogo ? (
                            <ContentBox padding={true}>
                                <VerticalGapOnChildren>
                                    <Slider
                                        id="distanceInitialsY"
                                        value={props.eventLogo.distanceInitialsY}
                                        handleChange={(value) => {
                                            const eventLogo = { ...props.eventLogo, distanceInitialsY: value };
                                            props.updateEventLogo(eventLogo);
                                        }}
                                        label="Avstånd initialer höjdled"
                                        name="distanceInitialsY"
                                        min={-14}
                                        max={14}
                                    />
                                    <Slider
                                        id="distanceInitialsX"
                                        value={props.eventLogo.distanceInitialsX}
                                        handleChange={(value) => {
                                            const eventLogo = { ...props.eventLogo, distanceInitialsX: value };
                                            props.updateEventLogo(eventLogo);
                                        }}
                                        label="Avstånd initialer sidled"
                                        name="distanceInitialsX"
                                        min={-14}
                                        max={14}
                                    />
                                </VerticalGapOnChildren>
                            </ContentBox>
                        ) : null}

                        {"colorText" in props.eventLogo ? (
                            <ContentBox padding={true}>
                                <div className={styles.formFieldWrapper}>
                                    <EventLogoColorPicker
                                        id="colorText"
                                        value={props.eventLogo.colorText}
                                        handleChange={(value) => {
                                            const eventLogo = { ...props.eventLogo, colorText: value };
                                            props.updateEventLogo(eventLogo);
                                        }}
                                        colorLabel="textfärg"
                                    />
                                </div>
                            </ContentBox>
                        ) : null}

                        {"colorBackground" in props.eventLogo ? (
                            <ContentBox padding={true}>
                                <div className={styles.formFieldWrapper}>
                                    <EventLogoColorPicker
                                        id="colorBackground"
                                        value={props.eventLogo.colorBackground}
                                        handleChange={(value) => {
                                            const eventLogo = { ...props.eventLogo, colorBackground: value };
                                            props.updateEventLogo(eventLogo);
                                        }}
                                        colorLabel="bakgrundsfärg"
                                    />
                                </div>
                            </ContentBox>
                        ) : null}
                    </VerticalGapOnChildren>
                </div>
                {/* Add preview for print as well in the future */}
                {props.site ? (
                    <div className={styles.logoWrapper}>
                        <ContentBox padding={true}>
                            <EmulateContentSurface site={props.site}>
                                <div className={styles.centerLogo}>
                                    <EventLogo type="SITE" siteTheme={props.site.theme} eventLogo={props.eventLogo} />
                                </div>
                            </EmulateContentSurface>
                        </ContentBox>
                    </div>
                ) : null}
            </div>
        </>
    );
}
